for (const method of ['log', 'info', 'warn', 'error', 'debug']) {
    window.console[method] = () => { };
}
